export default "/packs/images/sega-pay~72ac16e12f68590ef2304fd46f4a5de2.jpg";